import RSVPForm from "@/components/forms/RSVPForm";
import AccommodationPanel from "@/components/panels/AccommodationPanel";
import WelcomePanel from "@/components/panels/WelcomePanel";
import TravelPanel from "@/components/panels/TravelPanel";
import AboutUsPanel from "@/components/panels/AboutUsPanel";
import WeddingDayPanel from "@/components/panels/WeddingDayPanel";
import RegistryPanel from "@/components/panels/RegistryPanel";
import FAQPanel from "@/components/panels/FAQPanel";

export default function PanelContent({ id }) {
  if (id === "welcome") return <WelcomePanel />;
  if (id === "recap") return <AboutUsPanel />;
  if (id === "timeline") return <WeddingDayPanel />;
  if (id === "travel") return <TravelPanel />;
  if (id === "accommodation") return <AccommodationPanel />;
  if (id === "registry") return <RegistryPanel />;
  if (id === "faqs") return <FAQPanel />;
  if (id === "rsvp") {
    return (
      <div data-testid="panel-block-rsvp">
        <RSVPForm />
      </div>
    );
  }
  return (
    <div data-testid="panel-block" className="min-h-[60vh] flex items-center justify-center">
      <div
        className="italic text-[#76232F] text-7xl md:text-8xl tracking-wider"
        style={{ fontFamily: "'Pinyon Script', cursive" }}
      >
        TBC
      </div>
    </div>
  );
}
